<template>
  <div>
    <v-simple-table>
      <tbody
        v-for="(careLabelGroup, index) in groupByCareLabels"
        :key="index">
        <tr class="bg-lighten-blue text-bold">
          <td>example</td>
          <td>label code</td>
          <td>total</td>
        </tr>
        <tr>
          <td
            v-if="careLabelGroup.prototype[0].careLabel"
            class="pa-1">
            <img
              width="200"
              :src="$convertImgix(`${careLabelGroup.prototype[0].careLabel.imageUrl}?w=1024`)"
              alt=""
              @click="previewImg(careLabelGroup.prototype[0].careLabel.imageUrl)">
          </td>
          <td v-if="careLabelGroup.prototype[0].careLabel">
            <p
              class="font-bold text-h6 mb-0">
              {{ careLabelGroup.prototype[0].careLabel.name }}
            </p>
          </td>
          <td
            v-else
            colspan="2">
            <p
              class="font-bold text-h6 mb-0">
              สินค้าที่ไม่ระบุ Care Label
            </p>
          </td>
          <td class="font-bold text-h6 mb-0">
            {{ careLabelGroup.total }}
          </td>
        </tr>
        <tr class="text-bold">
          <td>Sketch ID</td>
          <td></td>
          <td>qty</td>
        </tr>
        <tr
          v-for="(p, i) in careLabelGroup.prototype"
          :key="`selected-${i}`">
          <td>
            {{ p.sketchId }}
          </td>
          <td>
          </td>
          <td>
            {{ p.qty }}
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>
<script>
export default {
    props: {
        groupByCareLabels: {
            type: Object,
            default: () => {}
        }
    },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.bg-lighten-blue {
    background-color: #64B5F6;
}
</style>
